import { render } from "./FormRow.vue?vue&type=template&id=89f667ec&scoped=true&ts=true"
import script from "./FormRow.vue?vue&type=script&lang=ts"
export * from "./FormRow.vue?vue&type=script&lang=ts"

import "./form.scss?vue&type=style&index=0&id=89f667ec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f667ec"]])

export default __exports__